<template>
    <div class="item" @click="onPressNav('articleDetail', {id: item.id})">
            <p>{{item.name}}</p>
            <div>
                <p>{{item.create_time}}</p>
                <!-- <span>{{item.is_pass_text}}</span> -->
                <span v-if="item.is_pass === 0">未审核</span>
                <span v-if="item.is_pass === 1">审核通过</span>
                <span v-if="item.is_pass === -1">拒绝</span>
            </div>
    </div>
</template>
<script>
export default {
    name: "myArticleItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {
    },
};
</script>
<style lang="less" scoped>
.item {
    margin: 10px 15px;
    padding: 10px;
    background: #fff;

    > p {
        margin-bottom: 10px;
        font-size: 14px;
        color: #333;
    }

    > div {
        display: flex;
        align-items: center;

        > p {
            flex: 1;
            font-size: 13px;
            color: #666;
        }

        > span {
            font-size: 13px;
            color: #7181EB;
        }
    }
}
</style>